import api, {BodyData} from '../../utils/api';

export interface sendManualEmailsPayload extends BodyData {
    readonly homeseekerApplicationIds: string[];
    readonly subject: string;
    readonly message: string;
}

const sendManualEmails = async (data: sendManualEmailsPayload): Promise<void> => {
    await api.post('api/agency/mailing/send-manual-email', data);
}

export default sendManualEmails;
